/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单发票
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,
  orderType: "ORDER_TICKET" | "ORDER_GOOD" | "ORDER_VIDEO",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.InvoiceConfirmInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/order-invoice/${orderId}/${orderType}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
